import React, { useEffect, useState } from "react";
import { createAPI } from "services/api/api";

const QuickCraftRarityCalculator = ({ choosedOptions }) => {
  const [text, setText] = useState("Choose two or more rarities for calculating");
  const [isLoading, setIsLoading] = useState(false);
  const api = createAPI();

  useEffect(() => {
    const validOptions = choosedOptions.filter(
      (option) => option[`${option.label}_rarity`]
    );

    if (validOptions.length >= 2) {
      const params = validOptions
        .map((option) =>
          `${option.label}_rarity=${encodeURIComponent(option[`${option.label}_rarity`])}`
        )
        .join("&");

      setIsLoading(true);
      api
        .get(`/me/identity_rarity/params?${params}`)
        .then((response) => {
          setText(response.data.name);
        })
        .catch(() => {
          setText("Error calculating rarity");
        })
        .finally(() => setIsLoading(false));
    } else {
      setText("Please select at least two rarities to calculate.");
    }
  }, [choosedOptions]);

  return (
    <span className="craft-block__tip">
      Crafted Rarity: {isLoading ? "Calculating..." : text}
    </span>
  );
};

export default QuickCraftRarityCalculator;
